module.exports = __webpack_public_path__ + "static/img/SmartPlatform6.bab5923.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/SmartPlatform6.png
// module id = yfxh
// module chunks = 13